import React, { useEffect, useState } from 'react';
import { getAsmtById, getUserByUserId } from '../services/authService'; // Importing the required service

const AsmtListParticipants = ({ assessments, onStartNewAssessment }) => {
    const [asmtsData, setAsmtsData] = useState({});
    const [userDetails, setUserDetails] = useState({});

    useEffect(() => {
        const fetchAssessment = async (assessmentId) => {


            try {
                const assessmentData = await getAsmtById(assessmentId);
                setAsmtsData((prevData) => ({
                    ...prevData,
                    [assessmentId]: assessmentData,
                }));



            } catch (error) {
                console.error("Failed to fetch assessment:", error);
            }
        };

        const fetchUserDetails = async (userId) => {
            try {
                const userData = await getUserByUserId(userId); // Fetch user details by user_id
                setUserDetails((prevDetails) => ({
                    ...prevDetails,
                    [userId]: userData,
                }));
            } catch (error) {
                console.error("Failed to fetch user details:", error);
            }
        };

        assessments.forEach((assessment) => {
            let usrId = assessment.created_by_user
            if (!asmtsData[assessment.assessment_id]) {
                fetchAssessment(assessment.assessment_id);
            }
            if (!userDetails[assessment.created_by_user]) {
                fetchUserDetails(usrId); // Fetch user details if not already fetched
            }

        })

        ////console.log("asmt", assessments)


    }, [assessments, asmtsData, userDetails]);

    // ////console.log("userDetails", userDetails)




    return (
        <div className="p-4">
            {assessments.length === 0 ? (
                <>
                    <h2 style={{ fontFamily: "Helvetica" }} className="text-gray-700 mb-4 text-xl"> 360° Feedback Request </h2>
                    <div className="flex items-center justify-center h-96">

                        <p className="text-gray-500 text-xl font-semibold">No assessments found.</p>
                    </div>
                </>
            ) : (
                <>
                    <h2 style={{ fontFamily: "Helvetica" }} className="text-gray-700 mb-4 text-xl"> 360° Feedback Request </h2>
                    <div className="space-y-4 overflow-y-auto  min-h-[74vh] lg:min-h-32 max-h-96">
                        {assessments.slice().reverse().map((assessment) => (
                            <div key={assessment?.assessment_user_id} className="flex flex-col md:flex-row items-center bg-blue-100 p-4 rounded-lg">
                                <div className="w-12 h-12 bg-blue-500 text-white flex items-center justify-center rounded mb-4 md:mb-0 md:mr-4">
                                    {userDetails[assessment.user_id]
                                        ? `${userDetails[assessment.user_id].first_name.slice(0, 1)}${userDetails[assessment.user_id].last_name.slice(0, 1)}`
                                        : "NA"}
                                </div>
                                <div className="flex-1 text-center md:text-left mb-4 md:mb-0">
                                    <h3 className="font-bold">

                                    </h3>
                                </div>
                                <div className="flex-1 text-center md:text-left mb-4 md:mb-0">
                                    <h3  style={{ fontFamily: "Helvetica", fontSize:"13" }} className="font-bold">
                                        {/* Display first name or "self" */}
                                        {userDetails[assessment.created_by_user]
                                            ? `Initiated by ${userDetails[assessment.created_by_user].first_name}`
                                            : 'Initiated for self'}
                                        <p className="text-gray-500">
                                            {asmtsData[assessment.assessment_id]
                                                ? `on ${new Date(asmtsData[assessment.assessment_id].initiation_date).toLocaleDateString()}`
                                                : 'Loading...'}
                                        </p>
                                        {/* <p className='text-gray-500'>
                                            {asmtsData[assessment.assessment_id]?.completedCount || 0} /
                                            {asmtsData[assessment.assessment_id]?.totalParticipants || 0}  Completed
                                        </p> */}

                                    </h3>
                                </div>
                                <div className="flex-1 text-center md:text-left mb-4 md:mb-0">
                                    <h3 className="font-bold">
                                        <span className={assessment.status === 'Completed' ? 'text-green-500' : 'text-red-500'}>
                                            {assessment.status}
                                        </span>
                                    </h3>
                                </div>
                                <div className="flex-1 text-center md:text-left">
                                    {assessment.association_type === 'participant' && assessment.status === 'Completed' ? (
                                        ""
                                    ) : (
                                        <button
                                            onClick={() => onStartNewAssessment(assessment.assessment_id)}
                                            className="bg-blue-600 text-white px-4 py-2 rounded"
                                        >
                                            {assessment.status === 'Completed' ? 'View Report' : 'Respond'}
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default AsmtListParticipants;
